import { render, staticRenderFns } from "./institution.view.vue?vue&type=template&id=1785d281&"
import script from "./institution.view.ts?vue&type=script&lang=ts&"
export * from "./institution.view.ts?vue&type=script&lang=ts&"
import style0 from "@/assets/styles/common.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./institution.view.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports